export const standings = JSON.parse(`{
    "standings": [{
        "phase": {
            "id": "GNBAN17DY17C6HC",
            "names": {
                "short": "A",
                "default": "Grupo A"
            },
            "dateAndTimeInfo": {},
            "status": {},
            "typeDetail": "PHASE_GROUP",
            "phaseNumber": 1,
            "sportId": "GNFB17MNF4TH4KM",
            "relatedSportsEvents": [{
                "id": "GNA5MGHG2ZVX2RD",
                "type": "LEAGUE"
            }, {
                "id": "GN1HX6DXNM8Q39W",
                "type": "LEAGUE_SEASON"
            }, {
                "id": "GN8N2CJNFGC0M4G",
                "type": "PHASE",
                "typeDetail": "PHASE_ROUND",
                "depth": 1
            }],
            "navigationInfo": {}
        },
        "participants": [{
            "id": "GNBGY5M9KMN8E53",
            "names": {
                "default": "Catar",
                "short": "Catar",
                "full": "Catar",
                "abbreviation": "QAT"
            },
            "images": {
                "teamLogo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/102370.png"
            },
            "type": "TEAM",
            "typeDetail": "TEAM_NATIONAL",
            "nationality": {
                "names": {
                    "default": "Catar",
                    "abbreviation": "QAT"
                },
                "images": {
                    "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/9640.png"
                }
            },
            "properties": {},
            "stats": {
                "virtualGoalsFor": "0",
                "virtualMatches": "0",
                "matchesWon": "0",
                "virtualRank": "1",
                "virtualMatchesLost": "0",
                "virtualGoalsDifference": "0",
                "virtualMatchesDrawn": "0",
                "matches": "0",
                "goalsDifference": "0",
                "points": "0",
                "rankSort": "1",
                "matchesLost": "0",
                "goalsAgainst": "0",
                "virtualGoalsAgainst": "0",
                "virtualPoints": "0",
                "rank": "1",
                "matchesDrawn": "0",
                "virtualMatchesWon": "0",
                "goalsFor": "0",
                "virtualRankSort": "1"
            }
        }, {
            "id": "GN5NM2T728912WK",
            "names": {
                "default": "Ecuador",
                "short": "Ecuador",
                "full": "Ecuador",
                "abbreviation": "ECU"
            },
            "images": {
                "teamLogo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3065.png",
                "jersey": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/shirt_home/large/3065.png"
            },
            "type": "TEAM",
            "typeDetail": "TEAM_NATIONAL",
            "nationality": {
                "names": {
                    "default": "Ecuador",
                    "abbreviation": "ECU"
                },
                "images": {
                    "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/4333.png"
                }
            },
            "properties": {},
            "stats": {
                "virtualGoalsFor": "0",
                "virtualMatches": "0",
                "matchesWon": "0",
                "virtualRank": "1",
                "virtualMatchesLost": "0",
                "virtualGoalsDifference": "0",
                "virtualMatchesDrawn": "0",
                "matches": "0",
                "goalsDifference": "0",
                "points": "0",
                "rankSort": "2",
                "matchesLost": "0",
                "goalsAgainst": "0",
                "virtualGoalsAgainst": "0",
                "virtualPoints": "0",
                "rank": "1",
                "matchesDrawn": "0",
                "virtualMatchesWon": "0",
                "goalsFor": "0",
                "virtualRankSort": "2"
            }
        }, {
            "id": "GN6Z2A16KJ6HV46",
            "names": {
                "full": "Senegal",
                "abbreviation": "SEN",
                "default": "Senegal",
                "short": "Senegal"
            },
            "images": {
                "teamLogo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3026.png"
            },
            "type": "TEAM",
            "typeDetail": "TEAM_NATIONAL",
            "nationality": {
                "names": {
                    "default": "Senegal",
                    "abbreviation": "SEN"
                },
                "images": {
                    "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/4375.png"
                }
            },
            "properties": {},
            "stats": {
                "virtualGoalsFor": "0",
                "virtualMatches": "0",
                "matchesWon": "0",
                "virtualRank": "1",
                "virtualMatchesLost": "0",
                "virtualGoalsDifference": "0",
                "virtualMatchesDrawn": "0",
                "matches": "0",
                "goalsDifference": "0",
                "points": "0",
                "rankSort": "3",
                "matchesLost": "0",
                "goalsAgainst": "0",
                "virtualGoalsAgainst": "0",
                "virtualPoints": "0",
                "rank": "1",
                "matchesDrawn": "0",
                "virtualMatchesWon": "0",
                "goalsFor": "0",
                "virtualRankSort": "3"
            }
        }, {
            "id": "GN1NKHKNE81WZNW",
            "names": {
                "full": "Países Bajos",
                "short": "P. Bajos",
                "abbreviation": "NED",
                "default": "Países Bajos"
            },
            "images": {
                "jersey": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/shirt_home/large/411.png",
                "teamLogo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/411.png"
            },
            "type": "TEAM",
            "typeDetail": "TEAM_NATIONAL",
            "nationality": {
                "names": {
                    "default": "Holanda",
                    "abbreviation": "NED"
                },
                "images": {
                    "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2201.png"
                }
            },
            "properties": {},
            "stats": {
                "virtualGoalsFor": "0",
                "virtualMatches": "0",
                "matchesWon": "0",
                "virtualRank": "1",
                "virtualMatchesLost": "0",
                "virtualGoalsDifference": "0",
                "virtualMatchesDrawn": "0",
                "matches": "0",
                "goalsDifference": "0",
                "points": "0",
                "rankSort": "4",
                "matchesLost": "0",
                "goalsAgainst": "0",
                "virtualGoalsAgainst": "0",
                "virtualPoints": "0",
                "rank": "1",
                "matchesDrawn": "0",
                "virtualMatchesWon": "0",
                "goalsFor": "0",
                "virtualRankSort": "4"
            }
        }],
        "classifications": [{
            "id": "GS0005V0050WPG5",
            "names": {
                "default": "Puntos",
                "short": "Ptos."
            },
            "statKey": "points",
            "sort": "DESC",
            "order": 1,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WPG7",
            "names": {
                "default": "Partidos",
                "short": "P"
            },
            "statKey": "matches",
            "sort": "DESC",
            "order": 3,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WPG8",
            "names": {
                "short": "W",
                "default": "Won"
            },
            "statKey": "matchesWon",
            "sort": "DESC",
            "order": 4,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WPG9",
            "names": {
                "default": "Drawn",
                "short": "D"
            },
            "statKey": "matchesDrawn",
            "sort": "DESC",
            "order": 5,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WPGB",
            "names": {
                "default": "Lost",
                "short": "L"
            },
            "statKey": "matchesLost",
            "sort": "DESC",
            "order": 6,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WPGC",
            "names": {
                "default": "goles a favor",
                "short": "GF"
            },
            "statKey": "goalsFor",
            "sort": "DESC",
            "order": 7,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WPGD",
            "names": {
                "short": "GC",
                "default": "goles en contra"
            },
            "statKey": "goalsAgainst",
            "sort": "DESC",
            "order": 8,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WPGF",
            "names": {
                "default": "Diferencia de goles",
                "short": "GD"
            },
            "statKey": "goalsDifference",
            "sort": "DESC",
            "order": 9,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WPGG",
            "names": {
                "short": "AGD",
                "default": "Away Goal Difference"
            },
            "statKey": "awayGoalsDifference",
            "sort": "DESC",
            "order": 10,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WPGH",
            "names": {
                "short": "HGD",
                "default": "Home Goal Difference"
            },
            "statKey": "homeGoalsDifference",
            "sort": "DESC",
            "order": 11,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WPGJ",
            "names": {
                "default": "Home Points",
                "short": "HP"
            },
            "statKey": "homePoints",
            "sort": "DESC",
            "order": 12,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WPGN",
            "names": {
                "default": "Home Matches",
                "short": "HM"
            },
            "statKey": "homeMatches",
            "sort": "DESC",
            "order": 14,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WPGP",
            "names": {
                "default": "Won Home",
                "short": "WH"
            },
            "statKey": "homeMatchesWon",
            "sort": "DESC",
            "order": 15,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WPGR",
            "names": {
                "default": "Drawn Home",
                "short": "DH"
            },
            "statKey": "homeMatchesDrawn",
            "sort": "DESC",
            "order": 16,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WPGS",
            "names": {
                "default": "Lost Home",
                "short": "LH"
            },
            "statKey": "homeMatchesLost",
            "sort": "DESC",
            "order": 17,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WPGT",
            "names": {
                "default": "Home Goals For",
                "short": "HGF"
            },
            "statKey": "homeGoalsFor",
            "sort": "DESC",
            "order": 18,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WPGV",
            "names": {
                "short": "HGA",
                "default": "Home Goals Against"
            },
            "statKey": "homeGoalsAgainst",
            "sort": "DESC",
            "order": 19,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WPGW",
            "names": {
                "short": "AP",
                "default": "Away Points"
            },
            "statKey": "awayPoints",
            "sort": "DESC",
            "order": 20,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WPGZ",
            "names": {
                "default": "Away Matches",
                "short": "AM"
            },
            "statKey": "awayMatches",
            "sort": "DESC",
            "order": 22,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WPGb",
            "names": {
                "short": "AW",
                "default": "Away Won"
            },
            "statKey": "awayMatchesWon",
            "sort": "DESC",
            "order": 23,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WPGh",
            "names": {
                "default": "Away Drawn",
                "short": "AD"
            },
            "statKey": "awayMatchesDrawn",
            "sort": "DESC",
            "order": 24,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WPGm",
            "names": {
                "short": "AL",
                "default": "Away Lost"
            },
            "statKey": "awayMatchesLost",
            "sort": "DESC",
            "order": 25,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WPGr",
            "names": {
                "short": "AGF",
                "default": "Away Goals For"
            },
            "statKey": "awayGoalsFor",
            "sort": "DESC",
            "order": 26,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WPGt",
            "names": {
                "short": "AGA",
                "default": "Away Goals Against"
            },
            "statKey": "awayGoalsAgainst",
            "sort": "DESC",
            "order": 27,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WPH0",
            "names": {
                "short": "MIN",
                "default": "Min Rank"
            },
            "statKey": "minRank",
            "sort": "DESC",
            "order": 28,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WPH1",
            "names": {
                "default": "Max Rank",
                "short": "MAX"
            },
            "statKey": "maxRank",
            "sort": "DESC",
            "order": 29,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WPHm",
            "names": {
                "default": "Win percentage",
                "short": "PCT"
            },
            "statKey": "winPercentage",
            "sort": "DESC",
            "order": 57,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WPHr",
            "names": {
                "default": "Home win percentage",
                "short": "HPCT"
            },
            "statKey": "homeWinPercentage",
            "sort": "DESC",
            "order": 58,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WPHt",
            "names": {
                "default": "Away Win Percentage",
                "short": "APCT"
            },
            "statKey": "awayWinPercentage",
            "sort": "DESC",
            "order": 59,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WPJ0",
            "names": {
                "default": "Rango",
                "short": "Clas."
            },
            "statKey": "rank",
            "sort": "ASC",
            "order": 60,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WPWZ",
            "names": {
                "short": "PR",
                "default": "Previous Rank"
            },
            "statKey": "prevRank",
            "sort": "ASC",
            "order": 61,
            "participantType": "TEAM"
        }, {
            "id": "GNEC4KEHTX9ZCEZ",
            "names": {
                "default": "General Classification"
            },
            "statKey": "generalClassification",
            "participantType": "TEAM"
        }]
    }, {
        "phase": {
            "id": "GNFP1FYJ0XFHG2K",
            "names": {
                "default": "Grupo B",
                "short": "B"
            },
            "dateAndTimeInfo": {},
            "status": {},
            "typeDetail": "PHASE_GROUP",
            "phaseNumber": 2,
            "sportId": "GNFB17MNF4TH4KM",
            "relatedSportsEvents": [{
                "id": "GNA5MGHG2ZVX2RD",
                "type": "LEAGUE"
            }, {
                "id": "GN1HX6DXNM8Q39W",
                "type": "LEAGUE_SEASON"
            }, {
                "id": "GN8N2CJNFGC0M4G",
                "type": "PHASE",
                "typeDetail": "PHASE_ROUND",
                "depth": 1
            }],
            "navigationInfo": {}
        },
        "participants": [{
            "id": "GNEWS27CQRA7F8Q",
            "names": {
                "default": "Inglaterra",
                "abbreviation": "ENG",
                "short": "Inglaterra",
                "full": "Inglaterra"
            },
            "images": {
                "jersey": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/shirt_home/large/436.png",
                "teamLogo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/436.png"
            },
            "type": "TEAM",
            "typeDetail": "TEAM_NATIONAL",
            "nationality": {
                "names": {
                    "default": "Inglaterra",
                    "abbreviation": "ENG"
                },
                "images": {
                    "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2208.png"
                }
            },
            "properties": {},
            "stats": {
                "virtualGoalsFor": "0",
                "virtualMatches": "0",
                "matchesWon": "0",
                "virtualRank": "1",
                "virtualMatchesLost": "0",
                "virtualGoalsDifference": "0",
                "virtualMatchesDrawn": "0",
                "matches": "0",
                "goalsDifference": "0",
                "points": "0",
                "rankSort": "1",
                "matchesLost": "0",
                "goalsAgainst": "0",
                "virtualGoalsAgainst": "0",
                "virtualPoints": "0",
                "rank": "1",
                "matchesDrawn": "0",
                "virtualMatchesWon": "0",
                "goalsFor": "0",
                "virtualRankSort": "1"
            }
        }, {
            "id": "GN5GBJ9XAE377F6",
            "names": {
                "default": "Irán",
                "abbreviation": "IRN",
                "full": "IR Iran",
                "short": "Irán"
            },
            "images": {
                "jersey": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/shirt_home/large/3033.png",
                "teamLogo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3033.png"
            },
            "type": "TEAM",
            "typeDetail": "TEAM_NATIONAL",
            "nationality": {
                "names": {
                    "abbreviation": "IRI",
                    "default": "Irán"
                },
                "images": {
                    "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/4348.png"
                }
            },
            "properties": {},
            "stats": {
                "virtualGoalsFor": "0",
                "virtualMatches": "0",
                "matchesWon": "0",
                "virtualRank": "1",
                "virtualMatchesLost": "0",
                "virtualGoalsDifference": "0",
                "virtualMatchesDrawn": "0",
                "matches": "0",
                "goalsDifference": "0",
                "points": "0",
                "rankSort": "2",
                "matchesLost": "0",
                "goalsAgainst": "0",
                "virtualGoalsAgainst": "0",
                "virtualPoints": "0",
                "rank": "1",
                "matchesDrawn": "0",
                "virtualMatchesWon": "0",
                "goalsFor": "0",
                "virtualRankSort": "2"
            }
        }, {
            "id": "GND4E8T69HJCYCD",
            "names": {
                "default": "Estados Unidos",
                "full": "Estados Unidos",
                "abbreviation": "USA",
                "short": "EE. UU."
            },
            "images": {
                "teamLogo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3019.png",
                "jersey": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/shirt_home/large/3019.png"
            },
            "type": "TEAM",
            "typeDetail": "TEAM_NATIONAL",
            "nationality": {
                "names": {
                    "abbreviation": "USA",
                    "default": "Estados Unidos"
                },
                "images": {
                    "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2209.png"
                }
            },
            "properties": {},
            "stats": {
                "virtualGoalsFor": "0",
                "virtualMatches": "0",
                "matchesWon": "0",
                "virtualRank": "1",
                "virtualMatchesLost": "0",
                "virtualGoalsDifference": "0",
                "virtualMatchesDrawn": "0",
                "matches": "0",
                "goalsDifference": "0",
                "points": "0",
                "rankSort": "3",
                "matchesLost": "0",
                "goalsAgainst": "0",
                "virtualGoalsAgainst": "0",
                "virtualPoints": "0",
                "rank": "1",
                "matchesDrawn": "0",
                "virtualMatchesWon": "0",
                "goalsFor": "0",
                "virtualRankSort": "3"
            }
        }, {
            "id": "GN31DA8MADTY6MC",
            "names": {
                "short": "Gales",
                "full": "Gales",
                "default": "Gales",
                "abbreviation": "WAL"
            },
            "images": {
                "jersey": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/shirt_home/large/3017.png",
                "teamLogo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3017.png"
            },
            "type": "TEAM",
            "typeDetail": "TEAM_NATIONAL",
            "nationality": {
                "names": {
                    "abbreviation": "WAL",
                    "default": "Gales"
                },
                "images": {
                    "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/4386.png"
                }
            },
            "properties": {},
            "stats": {
                "virtualGoalsFor": "0",
                "virtualMatches": "0",
                "matchesWon": "0",
                "virtualRank": "1",
                "virtualMatchesLost": "0",
                "virtualGoalsDifference": "0",
                "virtualMatchesDrawn": "0",
                "matches": "0",
                "goalsDifference": "0",
                "points": "0",
                "rankSort": "4",
                "matchesLost": "0",
                "goalsAgainst": "0",
                "virtualGoalsAgainst": "0",
                "virtualPoints": "0",
                "rank": "1",
                "matchesDrawn": "0",
                "virtualMatchesWon": "0",
                "goalsFor": "0",
                "virtualRankSort": "4"
            }
        }],
        "classifications": [{
            "id": "GS0005V0050WRFF",
            "names": {
                "default": "Puntos",
                "short": "Ptos."
            },
            "statKey": "points",
            "sort": "DESC",
            "order": 1,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WRFH",
            "names": {
                "default": "Partidos",
                "short": "P"
            },
            "statKey": "matches",
            "sort": "DESC",
            "order": 3,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WRFJ",
            "names": {
                "short": "W",
                "default": "Won"
            },
            "statKey": "matchesWon",
            "sort": "DESC",
            "order": 4,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WRFM",
            "names": {
                "default": "Drawn",
                "short": "D"
            },
            "statKey": "matchesDrawn",
            "sort": "DESC",
            "order": 5,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WRFN",
            "names": {
                "default": "Lost",
                "short": "L"
            },
            "statKey": "matchesLost",
            "sort": "DESC",
            "order": 6,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WRFP",
            "names": {
                "default": "goles a favor",
                "short": "GF"
            },
            "statKey": "goalsFor",
            "sort": "DESC",
            "order": 7,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WRFR",
            "names": {
                "short": "GC",
                "default": "goles en contra"
            },
            "statKey": "goalsAgainst",
            "sort": "DESC",
            "order": 8,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WRFS",
            "names": {
                "default": "Diferencia de goles",
                "short": "GD"
            },
            "statKey": "goalsDifference",
            "sort": "DESC",
            "order": 9,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WRFT",
            "names": {
                "short": "AGD",
                "default": "Away Goal Difference"
            },
            "statKey": "awayGoalsDifference",
            "sort": "DESC",
            "order": 10,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WRFV",
            "names": {
                "short": "HGD",
                "default": "Home Goal Difference"
            },
            "statKey": "homeGoalsDifference",
            "sort": "DESC",
            "order": 11,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WRFW",
            "names": {
                "default": "Home Points",
                "short": "HP"
            },
            "statKey": "homePoints",
            "sort": "DESC",
            "order": 12,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WRFZ",
            "names": {
                "default": "Home Matches",
                "short": "HM"
            },
            "statKey": "homeMatches",
            "sort": "DESC",
            "order": 14,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WRFb",
            "names": {
                "default": "Won Home",
                "short": "WH"
            },
            "statKey": "homeMatchesWon",
            "sort": "DESC",
            "order": 15,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WRFh",
            "names": {
                "default": "Drawn Home",
                "short": "DH"
            },
            "statKey": "homeMatchesDrawn",
            "sort": "DESC",
            "order": 16,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WRFm",
            "names": {
                "default": "Lost Home",
                "short": "LH"
            },
            "statKey": "homeMatchesLost",
            "sort": "DESC",
            "order": 17,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WRFr",
            "names": {
                "default": "Home Goals For",
                "short": "HGF"
            },
            "statKey": "homeGoalsFor",
            "sort": "DESC",
            "order": 18,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WRFt",
            "names": {
                "short": "HGA",
                "default": "Home Goals Against"
            },
            "statKey": "homeGoalsAgainst",
            "sort": "DESC",
            "order": 19,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WRG0",
            "names": {
                "short": "AP",
                "default": "Away Points"
            },
            "statKey": "awayPoints",
            "sort": "DESC",
            "order": 20,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WRG2",
            "names": {
                "default": "Away Matches",
                "short": "AM"
            },
            "statKey": "awayMatches",
            "sort": "DESC",
            "order": 22,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WRG3",
            "names": {
                "short": "AW",
                "default": "Away Won"
            },
            "statKey": "awayMatchesWon",
            "sort": "DESC",
            "order": 23,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WRG4",
            "names": {
                "default": "Away Drawn",
                "short": "AD"
            },
            "statKey": "awayMatchesDrawn",
            "sort": "DESC",
            "order": 24,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WRG5",
            "names": {
                "short": "AL",
                "default": "Away Lost"
            },
            "statKey": "awayMatchesLost",
            "sort": "DESC",
            "order": 25,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WRG6",
            "names": {
                "short": "AGF",
                "default": "Away Goals For"
            },
            "statKey": "awayGoalsFor",
            "sort": "DESC",
            "order": 26,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WRG7",
            "names": {
                "short": "AGA",
                "default": "Away Goals Against"
            },
            "statKey": "awayGoalsAgainst",
            "sort": "DESC",
            "order": 27,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WRG8",
            "names": {
                "short": "MIN",
                "default": "Min Rank"
            },
            "statKey": "minRank",
            "sort": "DESC",
            "order": 28,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WRG9",
            "names": {
                "default": "Max Rank",
                "short": "MAX"
            },
            "statKey": "maxRank",
            "sort": "DESC",
            "order": 29,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WRH5",
            "names": {
                "default": "Win percentage",
                "short": "PCT"
            },
            "statKey": "winPercentage",
            "sort": "DESC",
            "order": 57,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WRH6",
            "names": {
                "default": "Home win percentage",
                "short": "HPCT"
            },
            "statKey": "homeWinPercentage",
            "sort": "DESC",
            "order": 58,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WRH7",
            "names": {
                "default": "Away Win Percentage",
                "short": "APCT"
            },
            "statKey": "awayWinPercentage",
            "sort": "DESC",
            "order": 59,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WRH8",
            "names": {
                "default": "Rango",
                "short": "Clas."
            },
            "statKey": "rank",
            "sort": "ASC",
            "order": 60,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WRW2",
            "names": {
                "short": "PR",
                "default": "Previous Rank"
            },
            "statKey": "prevRank",
            "sort": "ASC",
            "order": 61,
            "participantType": "TEAM"
        }, {
            "id": "GN4890YW3HXX0WT",
            "names": {
                "default": "General Classification"
            },
            "statKey": "generalClassification",
            "participantType": "TEAM"
        }]
    }, {
        "phase": {
            "id": "GN6XTMAXA112QVK",
            "names": {
                "default": "Grupo C",
                "short": "C"
            },
            "dateAndTimeInfo": {},
            "status": {},
            "typeDetail": "PHASE_GROUP",
            "phaseNumber": 3,
            "sportId": "GNFB17MNF4TH4KM",
            "relatedSportsEvents": [{
                "id": "GNA5MGHG2ZVX2RD",
                "type": "LEAGUE"
            }, {
                "id": "GN1HX6DXNM8Q39W",
                "type": "LEAGUE_SEASON"
            }, {
                "id": "GN8N2CJNFGC0M4G",
                "type": "PHASE",
                "typeDetail": "PHASE_ROUND",
                "depth": 1
            }],
            "navigationInfo": {}
        },
        "participants": [{
            "id": "GN0Z3X6855XN43P",
            "names": {
                "full": "Argentina",
                "default": "Argentina",
                "abbreviation": "ARG",
                "short": "Argentina"
            },
            "images": {
                "teamLogo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3029.png",
                "jersey": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/shirt_home/large/3029.png"
            },
            "type": "TEAM",
            "typeDetail": "TEAM_NATIONAL",
            "nationality": {
                "names": {
                    "abbreviation": "ARG",
                    "default": "Argentina"
                },
                "images": {
                    "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2768.png"
                }
            },
            "properties": {},
            "stats": {
                "virtualGoalsFor": "0",
                "virtualMatches": "0",
                "matchesWon": "0",
                "virtualRank": "1",
                "virtualMatchesLost": "0",
                "virtualGoalsDifference": "0",
                "virtualMatchesDrawn": "0",
                "matches": "0",
                "goalsDifference": "0",
                "points": "0",
                "rankSort": "1",
                "matchesLost": "0",
                "goalsAgainst": "0",
                "virtualGoalsAgainst": "0",
                "virtualPoints": "0",
                "rank": "1",
                "matchesDrawn": "0",
                "virtualMatchesWon": "0",
                "goalsFor": "0",
                "virtualRankSort": "1"
            }
        }, {
            "id": "GN10Q0066RYCD63",
            "names": {
                "abbreviation": "KSA",
                "default": "Arabia Saudita",
                "short": "Arabia S.",
                "full": "Arabia Saudita"
            },
            "images": {
                "teamLogo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3072.png"
            },
            "type": "TEAM",
            "typeDetail": "TEAM_NATIONAL",
            "nationality": {
                "names": {
                    "default": "Arabia Saudita",
                    "abbreviation": "KSA"
                },
                "images": {
                    "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/4374.png"
                }
            },
            "properties": {},
            "stats": {
                "virtualGoalsFor": "0",
                "virtualMatches": "0",
                "matchesWon": "0",
                "virtualRank": "1",
                "virtualMatchesLost": "0",
                "virtualGoalsDifference": "0",
                "virtualMatchesDrawn": "0",
                "matches": "0",
                "goalsDifference": "0",
                "points": "0",
                "rankSort": "2",
                "matchesLost": "0",
                "goalsAgainst": "0",
                "virtualGoalsAgainst": "0",
                "virtualPoints": "0",
                "rank": "1",
                "matchesDrawn": "0",
                "virtualMatchesWon": "0",
                "goalsFor": "0",
                "virtualRankSort": "2"
            }
        }, {
            "id": "GN7VASH15HKYQA7",
            "names": {
                "full": "México",
                "abbreviation": "MEX",
                "default": "México",
                "short": "México"
            },
            "images": {
                "teamLogo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3010.png",
                "jersey": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/shirt_home/large/3010.png"
            },
            "type": "TEAM",
            "typeDetail": "TEAM_NATIONAL",
            "nationality": {
                "names": {
                    "abbreviation": "MEX",
                    "default": "México"
                },
                "images": {
                    "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2228.png"
                }
            },
            "properties": {},
            "stats": {
                "virtualGoalsFor": "0",
                "virtualMatches": "0",
                "matchesWon": "0",
                "virtualRank": "1",
                "virtualMatchesLost": "0",
                "virtualGoalsDifference": "0",
                "virtualMatchesDrawn": "0",
                "matches": "0",
                "goalsDifference": "0",
                "points": "0",
                "rankSort": "3",
                "matchesLost": "0",
                "goalsAgainst": "0",
                "virtualGoalsAgainst": "0",
                "virtualPoints": "0",
                "rank": "1",
                "matchesDrawn": "0",
                "virtualMatchesWon": "0",
                "goalsFor": "0",
                "virtualRankSort": "3"
            }
        }, {
            "id": "GN4Y21300EHG549",
            "names": {
                "default": "Polonia",
                "full": "Polonia",
                "short": "Polonia",
                "abbreviation": "POL"
            },
            "images": {
                "jersey": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/shirt_home/large/3006.png",
                "teamLogo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3006.png"
            },
            "type": "TEAM",
            "typeDetail": "TEAM_NATIONAL",
            "nationality": {
                "names": {
                    "abbreviation": "POL",
                    "default": "Polonia"
                },
                "images": {
                    "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2214.png"
                }
            },
            "properties": {},
            "stats": {
                "virtualGoalsFor": "0",
                "virtualMatches": "0",
                "matchesWon": "0",
                "virtualRank": "1",
                "virtualMatchesLost": "0",
                "virtualGoalsDifference": "0",
                "virtualMatchesDrawn": "0",
                "matches": "0",
                "goalsDifference": "0",
                "points": "0",
                "rankSort": "4",
                "matchesLost": "0",
                "goalsAgainst": "0",
                "virtualGoalsAgainst": "0",
                "virtualPoints": "0",
                "rank": "1",
                "matchesDrawn": "0",
                "virtualMatchesWon": "0",
                "goalsFor": "0",
                "virtualRankSort": "4"
            }
        }],
        "classifications": [{
            "id": "GS0005V0050WSDS",
            "names": {
                "default": "Puntos",
                "short": "Ptos."
            },
            "statKey": "points",
            "sort": "DESC",
            "order": 1,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WSDV",
            "names": {
                "default": "Partidos",
                "short": "P"
            },
            "statKey": "matches",
            "sort": "DESC",
            "order": 3,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WSDW",
            "names": {
                "short": "W",
                "default": "Won"
            },
            "statKey": "matchesWon",
            "sort": "DESC",
            "order": 4,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WSDX",
            "names": {
                "default": "Drawn",
                "short": "D"
            },
            "statKey": "matchesDrawn",
            "sort": "DESC",
            "order": 5,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WSDZ",
            "names": {
                "default": "Lost",
                "short": "L"
            },
            "statKey": "matchesLost",
            "sort": "DESC",
            "order": 6,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WSDb",
            "names": {
                "default": "goles a favor",
                "short": "GF"
            },
            "statKey": "goalsFor",
            "sort": "DESC",
            "order": 7,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WSDh",
            "names": {
                "short": "GC",
                "default": "goles en contra"
            },
            "statKey": "goalsAgainst",
            "sort": "DESC",
            "order": 8,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WSDm",
            "names": {
                "default": "Diferencia de goles",
                "short": "GD"
            },
            "statKey": "goalsDifference",
            "sort": "DESC",
            "order": 9,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WSDr",
            "names": {
                "short": "AGD",
                "default": "Away Goal Difference"
            },
            "statKey": "awayGoalsDifference",
            "sort": "DESC",
            "order": 10,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WSDt",
            "names": {
                "short": "HGD",
                "default": "Home Goal Difference"
            },
            "statKey": "homeGoalsDifference",
            "sort": "DESC",
            "order": 11,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WSF0",
            "names": {
                "default": "Home Points",
                "short": "HP"
            },
            "statKey": "homePoints",
            "sort": "DESC",
            "order": 12,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WSF2",
            "names": {
                "default": "Home Matches",
                "short": "HM"
            },
            "statKey": "homeMatches",
            "sort": "DESC",
            "order": 14,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WSF3",
            "names": {
                "default": "Won Home",
                "short": "WH"
            },
            "statKey": "homeMatchesWon",
            "sort": "DESC",
            "order": 15,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WSF4",
            "names": {
                "default": "Drawn Home",
                "short": "DH"
            },
            "statKey": "homeMatchesDrawn",
            "sort": "DESC",
            "order": 16,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WSF5",
            "names": {
                "default": "Lost Home",
                "short": "LH"
            },
            "statKey": "homeMatchesLost",
            "sort": "DESC",
            "order": 17,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WSF6",
            "names": {
                "default": "Home Goals For",
                "short": "HGF"
            },
            "statKey": "homeGoalsFor",
            "sort": "DESC",
            "order": 18,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WSF7",
            "names": {
                "short": "HGA",
                "default": "Home Goals Against"
            },
            "statKey": "homeGoalsAgainst",
            "sort": "DESC",
            "order": 19,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WSF8",
            "names": {
                "short": "AP",
                "default": "Away Points"
            },
            "statKey": "awayPoints",
            "sort": "DESC",
            "order": 20,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WSFB",
            "names": {
                "default": "Away Matches",
                "short": "AM"
            },
            "statKey": "awayMatches",
            "sort": "DESC",
            "order": 22,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WSFC",
            "names": {
                "short": "AW",
                "default": "Away Won"
            },
            "statKey": "awayMatchesWon",
            "sort": "DESC",
            "order": 23,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WSFD",
            "names": {
                "default": "Away Drawn",
                "short": "AD"
            },
            "statKey": "awayMatchesDrawn",
            "sort": "DESC",
            "order": 24,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WSFF",
            "names": {
                "short": "AL",
                "default": "Away Lost"
            },
            "statKey": "awayMatchesLost",
            "sort": "DESC",
            "order": 25,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WSFG",
            "names": {
                "short": "AGF",
                "default": "Away Goals For"
            },
            "statKey": "awayGoalsFor",
            "sort": "DESC",
            "order": 26,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WSFH",
            "names": {
                "short": "AGA",
                "default": "Away Goals Against"
            },
            "statKey": "awayGoalsAgainst",
            "sort": "DESC",
            "order": 27,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WSFJ",
            "names": {
                "short": "MIN",
                "default": "Min Rank"
            },
            "statKey": "minRank",
            "sort": "DESC",
            "order": 28,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WSFM",
            "names": {
                "default": "Max Rank",
                "short": "MAX"
            },
            "statKey": "maxRank",
            "sort": "DESC",
            "order": 29,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WSGF",
            "names": {
                "default": "Win percentage",
                "short": "PCT"
            },
            "statKey": "winPercentage",
            "sort": "DESC",
            "order": 57,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WSGG",
            "names": {
                "default": "Home win percentage",
                "short": "HPCT"
            },
            "statKey": "homeWinPercentage",
            "sort": "DESC",
            "order": 58,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WSGH",
            "names": {
                "default": "Away Win Percentage",
                "short": "APCT"
            },
            "statKey": "awayWinPercentage",
            "sort": "DESC",
            "order": 59,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WSGJ",
            "names": {
                "default": "Rango",
                "short": "Clas."
            },
            "statKey": "rank",
            "sort": "ASC",
            "order": 60,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WSVB",
            "names": {
                "short": "PR",
                "default": "Previous Rank"
            },
            "statKey": "prevRank",
            "sort": "ASC",
            "order": 61,
            "participantType": "TEAM"
        }, {
            "id": "GNFJ7EPAVDX58R2",
            "names": {
                "default": "General Classification"
            },
            "statKey": "generalClassification",
            "participantType": "TEAM"
        }]
    }, {
        "phase": {
            "id": "GN5H41S89V75M3R",
            "names": {
                "default": "Grupo D",
                "short": "D"
            },
            "dateAndTimeInfo": {},
            "status": {},
            "typeDetail": "PHASE_GROUP",
            "phaseNumber": 4,
            "sportId": "GNFB17MNF4TH4KM",
            "relatedSportsEvents": [{
                "id": "GNA5MGHG2ZVX2RD",
                "type": "LEAGUE"
            }, {
                "id": "GN1HX6DXNM8Q39W",
                "type": "LEAGUE_SEASON"
            }, {
                "id": "GN8N2CJNFGC0M4G",
                "type": "PHASE",
                "typeDetail": "PHASE_ROUND",
                "depth": 1
            }],
            "navigationInfo": {}
        },
        "participants": [{
            "id": "GNDKWAMRBAP7DVY",
            "names": {
                "abbreviation": "FRA",
                "default": "Francia",
                "full": "Francia",
                "short": "Francia"
            },
            "images": {
                "jersey": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/shirt_home/large/461.png",
                "teamLogo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/461.png"
            },
            "type": "TEAM",
            "typeDetail": "TEAM_NATIONAL",
            "nationality": {
                "names": {
                    "default": "Francia",
                    "abbreviation": "FRA"
                },
                "images": {
                    "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2202.png"
                }
            },
            "properties": {},
            "stats": {
                "virtualGoalsFor": "0",
                "virtualMatches": "0",
                "matchesWon": "0",
                "virtualRank": "1",
                "virtualMatchesLost": "0",
                "virtualGoalsDifference": "0",
                "virtualMatchesDrawn": "0",
                "matches": "0",
                "goalsDifference": "0",
                "points": "0",
                "rankSort": "1",
                "matchesLost": "0",
                "goalsAgainst": "0",
                "virtualGoalsAgainst": "0",
                "virtualPoints": "0",
                "rank": "1",
                "matchesDrawn": "0",
                "virtualMatchesWon": "0",
                "goalsFor": "0",
                "virtualRankSort": "1"
            }
        }, {
            "id": "GN4K3H1KMG1HR2E",
            "names": {
                "full": "Australia",
                "short": "Australia",
                "default": "Australia",
                "abbreviation": "AUS"
            },
            "images": {
                "jersey": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/shirt_home/large/3059.png",
                "teamLogo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3059.png"
            },
            "type": "TEAM",
            "typeDetail": "TEAM_NATIONAL",
            "nationality": {
                "names": {
                    "abbreviation": "AUS",
                    "default": "Australia"
                },
                "images": {
                    "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2229.png"
                }
            },
            "properties": {},
            "stats": {
                "virtualGoalsFor": "0",
                "virtualMatches": "0",
                "matchesWon": "0",
                "virtualRank": "1",
                "virtualMatchesLost": "0",
                "virtualGoalsDifference": "0",
                "virtualMatchesDrawn": "0",
                "matches": "0",
                "goalsDifference": "0",
                "points": "0",
                "rankSort": "2",
                "matchesLost": "0",
                "goalsAgainst": "0",
                "virtualGoalsAgainst": "0",
                "virtualPoints": "0",
                "rank": "1",
                "matchesDrawn": "0",
                "virtualMatchesWon": "0",
                "goalsFor": "0",
                "virtualRankSort": "2"
            }
        }, {
            "id": "GN35YRBCHES0H99",
            "names": {
                "full": "Dinamarca",
                "default": "Dinamarca",
                "abbreviation": "DEN",
                "short": "Dinamarca"
            },
            "images": {
                "teamLogo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/406.png",
                "jersey": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/shirt_home/large/406.png"
            },
            "type": "TEAM",
            "typeDetail": "TEAM_NATIONAL",
            "nationality": {
                "names": {
                    "default": "Dinamarca",
                    "abbreviation": "DEN"
                },
                "images": {
                    "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2220.png"
                }
            },
            "properties": {},
            "stats": {
                "virtualGoalsFor": "0",
                "virtualMatches": "0",
                "matchesWon": "0",
                "virtualRank": "1",
                "virtualMatchesLost": "0",
                "virtualGoalsDifference": "0",
                "virtualMatchesDrawn": "0",
                "matches": "0",
                "goalsDifference": "0",
                "points": "0",
                "rankSort": "3",
                "matchesLost": "0",
                "goalsAgainst": "0",
                "virtualGoalsAgainst": "0",
                "virtualPoints": "0",
                "rank": "1",
                "matchesDrawn": "0",
                "virtualMatchesWon": "0",
                "goalsFor": "0",
                "virtualRankSort": "3"
            }
        }, {
            "id": "GN0D2ZYT69QGC49",
            "names": {
                "short": "Túnez",
                "abbreviation": "TUN",
                "full": "Túnez",
                "default": "Túnez"
            },
            "images": {
                "teamLogo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3023.png"
            },
            "type": "TEAM",
            "typeDetail": "TEAM_NATIONAL",
            "nationality": {
                "names": {
                    "abbreviation": "TUN",
                    "default": "Túnez"
                },
                "images": {
                    "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2246.png"
                }
            },
            "properties": {},
            "stats": {
                "virtualGoalsFor": "0",
                "virtualMatches": "0",
                "matchesWon": "0",
                "virtualRank": "1",
                "virtualMatchesLost": "0",
                "virtualGoalsDifference": "0",
                "virtualMatchesDrawn": "0",
                "matches": "0",
                "goalsDifference": "0",
                "points": "0",
                "rankSort": "4",
                "matchesLost": "0",
                "goalsAgainst": "0",
                "virtualGoalsAgainst": "0",
                "virtualPoints": "0",
                "rank": "1",
                "matchesDrawn": "0",
                "virtualMatchesWon": "0",
                "goalsFor": "0",
                "virtualRankSort": "4"
            }
        }],
        "classifications": [{
            "id": "GS0005V0050WTCm",
            "names": {
                "default": "Puntos",
                "short": "Ptos."
            },
            "statKey": "points",
            "sort": "DESC",
            "order": 1,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WTCt",
            "names": {
                "default": "Partidos",
                "short": "P"
            },
            "statKey": "matches",
            "sort": "DESC",
            "order": 3,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WTD0",
            "names": {
                "short": "W",
                "default": "Won"
            },
            "statKey": "matchesWon",
            "sort": "DESC",
            "order": 4,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WTD1",
            "names": {
                "default": "Drawn",
                "short": "D"
            },
            "statKey": "matchesDrawn",
            "sort": "DESC",
            "order": 5,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WTD2",
            "names": {
                "default": "Lost",
                "short": "L"
            },
            "statKey": "matchesLost",
            "sort": "DESC",
            "order": 6,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WTD3",
            "names": {
                "default": "goles a favor",
                "short": "GF"
            },
            "statKey": "goalsFor",
            "sort": "DESC",
            "order": 7,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WTD4",
            "names": {
                "short": "GC",
                "default": "goles en contra"
            },
            "statKey": "goalsAgainst",
            "sort": "DESC",
            "order": 8,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WTD5",
            "names": {
                "default": "Diferencia de goles",
                "short": "GD"
            },
            "statKey": "goalsDifference",
            "sort": "DESC",
            "order": 9,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WTD6",
            "names": {
                "short": "AGD",
                "default": "Away Goal Difference"
            },
            "statKey": "awayGoalsDifference",
            "sort": "DESC",
            "order": 10,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WTD7",
            "names": {
                "short": "HGD",
                "default": "Home Goal Difference"
            },
            "statKey": "homeGoalsDifference",
            "sort": "DESC",
            "order": 11,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WTD8",
            "names": {
                "default": "Home Points",
                "short": "HP"
            },
            "statKey": "homePoints",
            "sort": "DESC",
            "order": 12,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WTDB",
            "names": {
                "default": "Home Matches",
                "short": "HM"
            },
            "statKey": "homeMatches",
            "sort": "DESC",
            "order": 14,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WTDC",
            "names": {
                "default": "Won Home",
                "short": "WH"
            },
            "statKey": "homeMatchesWon",
            "sort": "DESC",
            "order": 15,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WTDD",
            "names": {
                "default": "Drawn Home",
                "short": "DH"
            },
            "statKey": "homeMatchesDrawn",
            "sort": "DESC",
            "order": 16,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WTDF",
            "names": {
                "default": "Lost Home",
                "short": "LH"
            },
            "statKey": "homeMatchesLost",
            "sort": "DESC",
            "order": 17,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WTDG",
            "names": {
                "default": "Home Goals For",
                "short": "HGF"
            },
            "statKey": "homeGoalsFor",
            "sort": "DESC",
            "order": 18,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WTDH",
            "names": {
                "short": "HGA",
                "default": "Home Goals Against"
            },
            "statKey": "homeGoalsAgainst",
            "sort": "DESC",
            "order": 19,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WTDJ",
            "names": {
                "short": "AP",
                "default": "Away Points"
            },
            "statKey": "awayPoints",
            "sort": "DESC",
            "order": 20,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WTDN",
            "names": {
                "default": "Away Matches",
                "short": "AM"
            },
            "statKey": "awayMatches",
            "sort": "DESC",
            "order": 22,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WTDP",
            "names": {
                "short": "AW",
                "default": "Away Won"
            },
            "statKey": "awayMatchesWon",
            "sort": "DESC",
            "order": 23,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WTDR",
            "names": {
                "default": "Away Drawn",
                "short": "AD"
            },
            "statKey": "awayMatchesDrawn",
            "sort": "DESC",
            "order": 24,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WTDS",
            "names": {
                "short": "AL",
                "default": "Away Lost"
            },
            "statKey": "awayMatchesLost",
            "sort": "DESC",
            "order": 25,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WTDT",
            "names": {
                "short": "AGF",
                "default": "Away Goals For"
            },
            "statKey": "awayGoalsFor",
            "sort": "DESC",
            "order": 26,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WTDV",
            "names": {
                "short": "AGA",
                "default": "Away Goals Against"
            },
            "statKey": "awayGoalsAgainst",
            "sort": "DESC",
            "order": 27,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WTDW",
            "names": {
                "short": "MIN",
                "default": "Min Rank"
            },
            "statKey": "minRank",
            "sort": "DESC",
            "order": 28,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WTDX",
            "names": {
                "default": "Max Rank",
                "short": "MAX"
            },
            "statKey": "maxRank",
            "sort": "DESC",
            "order": 29,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WTFS",
            "names": {
                "default": "Win percentage",
                "short": "PCT"
            },
            "statKey": "winPercentage",
            "sort": "DESC",
            "order": 57,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WTFT",
            "names": {
                "default": "Home win percentage",
                "short": "HPCT"
            },
            "statKey": "homeWinPercentage",
            "sort": "DESC",
            "order": 58,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WTFV",
            "names": {
                "default": "Away Win Percentage",
                "short": "APCT"
            },
            "statKey": "awayWinPercentage",
            "sort": "DESC",
            "order": 59,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WTFW",
            "names": {
                "default": "Rango",
                "short": "Clas."
            },
            "statKey": "rank",
            "sort": "ASC",
            "order": 60,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WTTN",
            "names": {
                "short": "PR",
                "default": "Previous Rank"
            },
            "statKey": "prevRank",
            "sort": "ASC",
            "order": 61,
            "participantType": "TEAM"
        }, {
            "id": "GN21M71G1ZGXQMP",
            "names": {
                "default": "General Classification"
            },
            "statKey": "generalClassification",
            "participantType": "TEAM"
        }]
    }, {
        "phase": {
            "id": "GNFMX613A54R1CW",
            "names": {
                "default": "Grupo E",
                "short": "E"
            },
            "dateAndTimeInfo": {},
            "status": {},
            "typeDetail": "PHASE_GROUP",
            "phaseNumber": 5,
            "sportId": "GNFB17MNF4TH4KM",
            "relatedSportsEvents": [{
                "id": "GNA5MGHG2ZVX2RD",
                "type": "LEAGUE"
            }, {
                "id": "GN1HX6DXNM8Q39W",
                "type": "LEAGUE_SEASON"
            }, {
                "id": "GN8N2CJNFGC0M4G",
                "type": "PHASE",
                "typeDetail": "PHASE_ROUND",
                "depth": 1
            }],
            "navigationInfo": {}
        },
        "participants": [{
            "id": "GN8N1G480P5H6HV",
            "names": {
                "default": "España",
                "short": "España",
                "full": "España",
                "abbreviation": "ESP"
            },
            "images": {
                "teamLogo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/413.png",
                "jersey": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/shirt_home/large/413.png"
            },
            "type": "TEAM",
            "typeDetail": "TEAM_NATIONAL",
            "nationality": {
                "names": {
                    "default": "España",
                    "abbreviation": "ESP"
                },
                "images": {
                    "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2203.png"
                }
            },
            "properties": {},
            "stats": {
                "virtualGoalsFor": "0",
                "virtualMatches": "0",
                "matchesWon": "0",
                "virtualRank": "1",
                "virtualMatchesLost": "0",
                "virtualGoalsDifference": "0",
                "virtualMatchesDrawn": "0",
                "matches": "0",
                "goalsDifference": "0",
                "points": "0",
                "rankSort": "1",
                "matchesLost": "0",
                "goalsAgainst": "0",
                "virtualGoalsAgainst": "0",
                "virtualPoints": "0",
                "rank": "1",
                "matchesDrawn": "0",
                "virtualMatchesWon": "0",
                "goalsFor": "0",
                "virtualRankSort": "1"
            }
        }, {
            "id": "GNAMV9APZY4CSZ1",
            "names": {
                "full": "Costa Rica",
                "default": "Costa Rica",
                "short": "Costa Rica",
                "abbreviation": "CRC"
            },
            "images": {
                "teamLogo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3090.png",
                "jersey": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/shirt_home/large/3090.png"
            },
            "type": "TEAM",
            "typeDetail": "TEAM_NATIONAL",
            "nationality": {
                "names": {
                    "abbreviation": "CRC",
                    "default": "Costa Rica"
                },
                "images": {
                    "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2771.png"
                }
            },
            "properties": {},
            "stats": {
                "virtualGoalsFor": "0",
                "virtualMatches": "0",
                "matchesWon": "0",
                "virtualRank": "1",
                "virtualMatchesLost": "0",
                "virtualGoalsDifference": "0",
                "virtualMatchesDrawn": "0",
                "matches": "0",
                "goalsDifference": "0",
                "points": "0",
                "rankSort": "2",
                "matchesLost": "0",
                "goalsAgainst": "0",
                "virtualGoalsAgainst": "0",
                "virtualPoints": "0",
                "rank": "1",
                "matchesDrawn": "0",
                "virtualMatchesWon": "0",
                "goalsFor": "0",
                "virtualRankSort": "2"
            }
        }, {
            "id": "GN6T73QJMJT6PGT",
            "names": {
                "short": "Alemania",
                "default": "Alemania",
                "full": "Alemania",
                "abbreviation": "GER"
            },
            "images": {
                "jersey": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/shirt_home/large/1500.png",
                "teamLogo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/1500.png"
            },
            "type": "TEAM",
            "typeDetail": "TEAM_NATIONAL",
            "nationality": {
                "names": {
                    "abbreviation": "GER",
                    "default": "Alemania"
                },
                "images": {
                    "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2206.png"
                }
            },
            "properties": {},
            "stats": {
                "virtualGoalsFor": "0",
                "virtualMatches": "0",
                "matchesWon": "0",
                "virtualRank": "1",
                "virtualMatchesLost": "0",
                "virtualGoalsDifference": "0",
                "virtualMatchesDrawn": "0",
                "matches": "0",
                "goalsDifference": "0",
                "points": "0",
                "rankSort": "3",
                "matchesLost": "0",
                "goalsAgainst": "0",
                "virtualGoalsAgainst": "0",
                "virtualPoints": "0",
                "rank": "1",
                "matchesDrawn": "0",
                "virtualMatchesWon": "0",
                "goalsFor": "0",
                "virtualRankSort": "3"
            }
        }, {
            "id": "GN6AGN17D1B453T",
            "names": {
                "full": "Japón",
                "default": "Japón",
                "short": "Japón",
                "abbreviation": "JPN"
            },
            "images": {
                "teamLogo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3062.png",
                "jersey": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/shirt_home/large/3062.png"
            },
            "type": "TEAM",
            "typeDetail": "TEAM_NATIONAL",
            "nationality": {
                "names": {
                    "default": "Japón",
                    "abbreviation": "JPN"
                },
                "images": {
                    "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2241.png"
                }
            },
            "properties": {},
            "stats": {
                "virtualGoalsFor": "0",
                "virtualMatches": "0",
                "matchesWon": "0",
                "virtualRank": "1",
                "virtualMatchesLost": "0",
                "virtualGoalsDifference": "0",
                "virtualMatchesDrawn": "0",
                "matches": "0",
                "goalsDifference": "0",
                "points": "0",
                "rankSort": "4",
                "matchesLost": "0",
                "goalsAgainst": "0",
                "virtualGoalsAgainst": "0",
                "virtualPoints": "0",
                "rank": "1",
                "matchesDrawn": "0",
                "virtualMatchesWon": "0",
                "goalsFor": "0",
                "virtualRankSort": "4"
            }
        }],
        "classifications": [{
            "id": "GS0005V0050WVC5",
            "names": {
                "default": "Puntos",
                "short": "Ptos."
            },
            "statKey": "points",
            "sort": "DESC",
            "order": 1,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WVC7",
            "names": {
                "default": "Partidos",
                "short": "P"
            },
            "statKey": "matches",
            "sort": "DESC",
            "order": 3,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WVC8",
            "names": {
                "short": "W",
                "default": "Won"
            },
            "statKey": "matchesWon",
            "sort": "DESC",
            "order": 4,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WVC9",
            "names": {
                "default": "Drawn",
                "short": "D"
            },
            "statKey": "matchesDrawn",
            "sort": "DESC",
            "order": 5,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WVCB",
            "names": {
                "default": "Lost",
                "short": "L"
            },
            "statKey": "matchesLost",
            "sort": "DESC",
            "order": 6,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WVCC",
            "names": {
                "default": "goles a favor",
                "short": "GF"
            },
            "statKey": "goalsFor",
            "sort": "DESC",
            "order": 7,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WVCD",
            "names": {
                "short": "GC",
                "default": "goles en contra"
            },
            "statKey": "goalsAgainst",
            "sort": "DESC",
            "order": 8,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WVCF",
            "names": {
                "default": "Diferencia de goles",
                "short": "GD"
            },
            "statKey": "goalsDifference",
            "sort": "DESC",
            "order": 9,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WVCG",
            "names": {
                "short": "AGD",
                "default": "Away Goal Difference"
            },
            "statKey": "awayGoalsDifference",
            "sort": "DESC",
            "order": 10,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WVCH",
            "names": {
                "short": "HGD",
                "default": "Home Goal Difference"
            },
            "statKey": "homeGoalsDifference",
            "sort": "DESC",
            "order": 11,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WVCJ",
            "names": {
                "default": "Home Points",
                "short": "HP"
            },
            "statKey": "homePoints",
            "sort": "DESC",
            "order": 12,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WVCN",
            "names": {
                "default": "Home Matches",
                "short": "HM"
            },
            "statKey": "homeMatches",
            "sort": "DESC",
            "order": 14,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WVCP",
            "names": {
                "default": "Won Home",
                "short": "WH"
            },
            "statKey": "homeMatchesWon",
            "sort": "DESC",
            "order": 15,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WVCR",
            "names": {
                "default": "Drawn Home",
                "short": "DH"
            },
            "statKey": "homeMatchesDrawn",
            "sort": "DESC",
            "order": 16,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WVCS",
            "names": {
                "default": "Lost Home",
                "short": "LH"
            },
            "statKey": "homeMatchesLost",
            "sort": "DESC",
            "order": 17,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WVCT",
            "names": {
                "default": "Home Goals For",
                "short": "HGF"
            },
            "statKey": "homeGoalsFor",
            "sort": "DESC",
            "order": 18,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WVCV",
            "names": {
                "short": "HGA",
                "default": "Home Goals Against"
            },
            "statKey": "homeGoalsAgainst",
            "sort": "DESC",
            "order": 19,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WVCW",
            "names": {
                "short": "AP",
                "default": "Away Points"
            },
            "statKey": "awayPoints",
            "sort": "DESC",
            "order": 20,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WVCZ",
            "names": {
                "default": "Away Matches",
                "short": "AM"
            },
            "statKey": "awayMatches",
            "sort": "DESC",
            "order": 22,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WVCb",
            "names": {
                "short": "AW",
                "default": "Away Won"
            },
            "statKey": "awayMatchesWon",
            "sort": "DESC",
            "order": 23,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WVCh",
            "names": {
                "default": "Away Drawn",
                "short": "AD"
            },
            "statKey": "awayMatchesDrawn",
            "sort": "DESC",
            "order": 24,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WVCm",
            "names": {
                "short": "AL",
                "default": "Away Lost"
            },
            "statKey": "awayMatchesLost",
            "sort": "DESC",
            "order": 25,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WVCr",
            "names": {
                "short": "AGF",
                "default": "Away Goals For"
            },
            "statKey": "awayGoalsFor",
            "sort": "DESC",
            "order": 26,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WVCt",
            "names": {
                "short": "AGA",
                "default": "Away Goals Against"
            },
            "statKey": "awayGoalsAgainst",
            "sort": "DESC",
            "order": 27,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WVD0",
            "names": {
                "short": "MIN",
                "default": "Min Rank"
            },
            "statKey": "minRank",
            "sort": "DESC",
            "order": 28,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WVD1",
            "names": {
                "default": "Max Rank",
                "short": "MAX"
            },
            "statKey": "maxRank",
            "sort": "DESC",
            "order": 29,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WVDm",
            "names": {
                "default": "Win percentage",
                "short": "PCT"
            },
            "statKey": "winPercentage",
            "sort": "DESC",
            "order": 57,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WVDr",
            "names": {
                "default": "Home win percentage",
                "short": "HPCT"
            },
            "statKey": "homeWinPercentage",
            "sort": "DESC",
            "order": 58,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WVDt",
            "names": {
                "default": "Away Win Percentage",
                "short": "APCT"
            },
            "statKey": "awayWinPercentage",
            "sort": "DESC",
            "order": 59,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WVF0",
            "names": {
                "default": "Rango",
                "short": "Clas."
            },
            "statKey": "rank",
            "sort": "ASC",
            "order": 60,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WVSZ",
            "names": {
                "short": "PR",
                "default": "Previous Rank"
            },
            "statKey": "prevRank",
            "sort": "ASC",
            "order": 61,
            "participantType": "TEAM"
        }, {
            "id": "GNBXTPV25NWVQRC",
            "names": {
                "default": "General Classification"
            },
            "statKey": "generalClassification",
            "participantType": "TEAM"
        }]
    }, {
        "phase": {
            "id": "GNAQVRWVJVGM77G",
            "names": {
                "short": "F",
                "default": "Grupo F"
            },
            "dateAndTimeInfo": {},
            "status": {},
            "typeDetail": "PHASE_GROUP",
            "phaseNumber": 6,
            "sportId": "GNFB17MNF4TH4KM",
            "relatedSportsEvents": [{
                "id": "GNA5MGHG2ZVX2RD",
                "type": "LEAGUE"
            }, {
                "id": "GN1HX6DXNM8Q39W",
                "type": "LEAGUE_SEASON"
            }, {
                "id": "GN8N2CJNFGC0M4G",
                "type": "PHASE",
                "typeDetail": "PHASE_ROUND",
                "depth": 1
            }],
            "navigationInfo": {}
        },
        "participants": [{
            "id": "GNE0VFY10J2Q7JP",
            "names": {
                "full": "Bélgica",
                "short": "Bélgica",
                "default": "Bélgica",
                "abbreviation": "BEL"
            },
            "images": {
                "jersey": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/shirt_home/large/3004.png",
                "teamLogo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3004.png"
            },
            "type": "TEAM",
            "typeDetail": "TEAM_NATIONAL",
            "nationality": {
                "names": {
                    "default": "Bélgica",
                    "abbreviation": "BEL"
                },
                "images": {
                    "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2205.png"
                }
            },
            "properties": {},
            "stats": {
                "virtualGoalsFor": "0",
                "virtualMatches": "0",
                "matchesWon": "0",
                "virtualRank": "1",
                "virtualMatchesLost": "0",
                "virtualGoalsDifference": "0",
                "virtualMatchesDrawn": "0",
                "matches": "0",
                "goalsDifference": "0",
                "points": "0",
                "rankSort": "1",
                "matchesLost": "0",
                "goalsAgainst": "0",
                "virtualGoalsAgainst": "0",
                "virtualPoints": "0",
                "rank": "1",
                "matchesDrawn": "0",
                "virtualMatchesWon": "0",
                "goalsFor": "0",
                "virtualRankSort": "1"
            }
        }, {
            "id": "GN9PN5ZEH07GF9F",
            "names": {
                "abbreviation": "CAN",
                "default": "Canadá",
                "full": "Canadá",
                "short": "Canadá"
            },
            "images": {
                "teamLogo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3049.png"
            },
            "type": "TEAM",
            "typeDetail": "TEAM_NATIONAL",
            "nationality": {
                "names": {
                    "abbreviation": "CAN",
                    "default": "Canadá"
                },
                "images": {
                    "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2231.png"
                }
            },
            "properties": {},
            "stats": {
                "virtualGoalsFor": "0",
                "virtualMatches": "0",
                "matchesWon": "0",
                "virtualRank": "1",
                "virtualMatchesLost": "0",
                "virtualGoalsDifference": "0",
                "virtualMatchesDrawn": "0",
                "matches": "0",
                "goalsDifference": "0",
                "points": "0",
                "rankSort": "2",
                "matchesLost": "0",
                "goalsAgainst": "0",
                "virtualGoalsAgainst": "0",
                "virtualPoints": "0",
                "rank": "1",
                "matchesDrawn": "0",
                "virtualMatchesWon": "0",
                "goalsFor": "0",
                "virtualRankSort": "2"
            }
        }, {
            "id": "GNA0R58H42SG1NV",
            "names": {
                "abbreviation": "MAR",
                "full": "Marruecos",
                "short": "Marruecos",
                "default": "Marruecos"
            },
            "images": {
                "teamLogo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3014.png"
            },
            "type": "TEAM",
            "typeDetail": "TEAM_NATIONAL",
            "nationality": {
                "names": {
                    "default": "Marruecos",
                    "abbreviation": "MAR"
                },
                "images": {
                    "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2779.png"
                }
            },
            "properties": {},
            "stats": {
                "virtualGoalsFor": "0",
                "virtualMatches": "0",
                "matchesWon": "0",
                "virtualRank": "1",
                "virtualMatchesLost": "0",
                "virtualGoalsDifference": "0",
                "virtualMatchesDrawn": "0",
                "matches": "0",
                "goalsDifference": "0",
                "points": "0",
                "rankSort": "3",
                "matchesLost": "0",
                "goalsAgainst": "0",
                "virtualGoalsAgainst": "0",
                "virtualPoints": "0",
                "rank": "1",
                "matchesDrawn": "0",
                "virtualMatchesWon": "0",
                "goalsFor": "0",
                "virtualRankSort": "3"
            }
        }, {
            "id": "GNAMDSYB2VWJCZY",
            "names": {
                "abbreviation": "CRO",
                "full": "Croacia",
                "default": "Croacia",
                "short": "Croacia"
            },
            "images": {
                "jersey": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/shirt_home/large/523.png",
                "teamLogo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/523.png"
            },
            "type": "TEAM",
            "typeDetail": "TEAM_NATIONAL",
            "nationality": {
                "names": {
                    "abbreviation": "CRO",
                    "default": "Croacia"
                },
                "images": {
                    "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/4354.png"
                }
            },
            "properties": {},
            "stats": {
                "virtualGoalsFor": "0",
                "virtualMatches": "0",
                "matchesWon": "0",
                "virtualRank": "1",
                "virtualMatchesLost": "0",
                "virtualGoalsDifference": "0",
                "virtualMatchesDrawn": "0",
                "matches": "0",
                "goalsDifference": "0",
                "points": "0",
                "rankSort": "4",
                "matchesLost": "0",
                "goalsAgainst": "0",
                "virtualGoalsAgainst": "0",
                "virtualPoints": "0",
                "rank": "1",
                "matchesDrawn": "0",
                "virtualMatchesWon": "0",
                "goalsFor": "0",
                "virtualRankSort": "4"
            }
        }],
        "classifications": [{
            "id": "GS0005V0050WWBF",
            "names": {
                "default": "Puntos",
                "short": "Ptos."
            },
            "statKey": "points",
            "sort": "DESC",
            "order": 1,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WWBH",
            "names": {
                "default": "Partidos",
                "short": "P"
            },
            "statKey": "matches",
            "sort": "DESC",
            "order": 3,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WWBJ",
            "names": {
                "short": "W",
                "default": "Won"
            },
            "statKey": "matchesWon",
            "sort": "DESC",
            "order": 4,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WWBM",
            "names": {
                "default": "Drawn",
                "short": "D"
            },
            "statKey": "matchesDrawn",
            "sort": "DESC",
            "order": 5,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WWBN",
            "names": {
                "default": "Lost",
                "short": "L"
            },
            "statKey": "matchesLost",
            "sort": "DESC",
            "order": 6,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WWBP",
            "names": {
                "default": "goles a favor",
                "short": "GF"
            },
            "statKey": "goalsFor",
            "sort": "DESC",
            "order": 7,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WWBR",
            "names": {
                "short": "GC",
                "default": "goles en contra"
            },
            "statKey": "goalsAgainst",
            "sort": "DESC",
            "order": 8,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WWBS",
            "names": {
                "default": "Diferencia de goles",
                "short": "GD"
            },
            "statKey": "goalsDifference",
            "sort": "DESC",
            "order": 9,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WWBT",
            "names": {
                "short": "AGD",
                "default": "Away Goal Difference"
            },
            "statKey": "awayGoalsDifference",
            "sort": "DESC",
            "order": 10,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WWBV",
            "names": {
                "short": "HGD",
                "default": "Home Goal Difference"
            },
            "statKey": "homeGoalsDifference",
            "sort": "DESC",
            "order": 11,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WWBW",
            "names": {
                "default": "Home Points",
                "short": "HP"
            },
            "statKey": "homePoints",
            "sort": "DESC",
            "order": 12,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WWBZ",
            "names": {
                "default": "Home Matches",
                "short": "HM"
            },
            "statKey": "homeMatches",
            "sort": "DESC",
            "order": 14,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WWBb",
            "names": {
                "default": "Won Home",
                "short": "WH"
            },
            "statKey": "homeMatchesWon",
            "sort": "DESC",
            "order": 15,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WWBh",
            "names": {
                "default": "Drawn Home",
                "short": "DH"
            },
            "statKey": "homeMatchesDrawn",
            "sort": "DESC",
            "order": 16,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WWBm",
            "names": {
                "default": "Lost Home",
                "short": "LH"
            },
            "statKey": "homeMatchesLost",
            "sort": "DESC",
            "order": 17,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WWBr",
            "names": {
                "default": "Home Goals For",
                "short": "HGF"
            },
            "statKey": "homeGoalsFor",
            "sort": "DESC",
            "order": 18,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WWBt",
            "names": {
                "short": "HGA",
                "default": "Home Goals Against"
            },
            "statKey": "homeGoalsAgainst",
            "sort": "DESC",
            "order": 19,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WWC0",
            "names": {
                "short": "AP",
                "default": "Away Points"
            },
            "statKey": "awayPoints",
            "sort": "DESC",
            "order": 20,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WWC2",
            "names": {
                "default": "Away Matches",
                "short": "AM"
            },
            "statKey": "awayMatches",
            "sort": "DESC",
            "order": 22,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WWC3",
            "names": {
                "short": "AW",
                "default": "Away Won"
            },
            "statKey": "awayMatchesWon",
            "sort": "DESC",
            "order": 23,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WWC4",
            "names": {
                "default": "Away Drawn",
                "short": "AD"
            },
            "statKey": "awayMatchesDrawn",
            "sort": "DESC",
            "order": 24,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WWC5",
            "names": {
                "short": "AL",
                "default": "Away Lost"
            },
            "statKey": "awayMatchesLost",
            "sort": "DESC",
            "order": 25,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WWC6",
            "names": {
                "short": "AGF",
                "default": "Away Goals For"
            },
            "statKey": "awayGoalsFor",
            "sort": "DESC",
            "order": 26,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WWC7",
            "names": {
                "short": "AGA",
                "default": "Away Goals Against"
            },
            "statKey": "awayGoalsAgainst",
            "sort": "DESC",
            "order": 27,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WWC8",
            "names": {
                "short": "MIN",
                "default": "Min Rank"
            },
            "statKey": "minRank",
            "sort": "DESC",
            "order": 28,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WWC9",
            "names": {
                "default": "Max Rank",
                "short": "MAX"
            },
            "statKey": "maxRank",
            "sort": "DESC",
            "order": 29,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WWD5",
            "names": {
                "default": "Win percentage",
                "short": "PCT"
            },
            "statKey": "winPercentage",
            "sort": "DESC",
            "order": 57,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WWD6",
            "names": {
                "default": "Home win percentage",
                "short": "HPCT"
            },
            "statKey": "homeWinPercentage",
            "sort": "DESC",
            "order": 58,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WWD7",
            "names": {
                "default": "Away Win Percentage",
                "short": "APCT"
            },
            "statKey": "awayWinPercentage",
            "sort": "DESC",
            "order": 59,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WWD8",
            "names": {
                "default": "Rango",
                "short": "Clas."
            },
            "statKey": "rank",
            "sort": "ASC",
            "order": 60,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WWS2",
            "names": {
                "short": "PR",
                "default": "Previous Rank"
            },
            "statKey": "prevRank",
            "sort": "ASC",
            "order": 61,
            "participantType": "TEAM"
        }, {
            "id": "GNDF8TTZ9TZGPZ1",
            "names": {
                "default": "General Classification"
            },
            "statKey": "generalClassification",
            "participantType": "TEAM"
        }]
    }, {
        "phase": {
            "id": "GN0VS7X9CKVQ2BK",
            "names": {
                "short": "G",
                "default": "Grupo G"
            },
            "dateAndTimeInfo": {},
            "status": {},
            "typeDetail": "PHASE_GROUP",
            "phaseNumber": 7,
            "sportId": "GNFB17MNF4TH4KM",
            "relatedSportsEvents": [{
                "id": "GNA5MGHG2ZVX2RD",
                "type": "LEAGUE"
            }, {
                "id": "GN1HX6DXNM8Q39W",
                "type": "LEAGUE_SEASON"
            }, {
                "id": "GN8N2CJNFGC0M4G",
                "type": "PHASE",
                "typeDetail": "PHASE_ROUND",
                "depth": 1
            }],
            "navigationInfo": {}
        },
        "participants": [{
            "id": "GNDPVBPY1CBN882",
            "names": {
                "full": "Brasil",
                "default": "Brasil",
                "abbreviation": "BRA",
                "short": "Brasil"
            },
            "images": {
                "jersey": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/shirt_home/large/1035.png",
                "teamLogo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/1035.png"
            },
            "type": "TEAM",
            "typeDetail": "TEAM_NATIONAL",
            "nationality": {
                "names": {
                    "default": "Brasil",
                    "abbreviation": "BRA"
                },
                "images": {
                    "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2235.png"
                }
            },
            "properties": {},
            "stats": {
                "virtualGoalsFor": "0",
                "virtualMatches": "0",
                "matchesWon": "0",
                "virtualRank": "1",
                "virtualMatchesLost": "0",
                "virtualGoalsDifference": "0",
                "virtualMatchesDrawn": "0",
                "matches": "0",
                "goalsDifference": "0",
                "points": "0",
                "rankSort": "1",
                "matchesLost": "0",
                "goalsAgainst": "0",
                "virtualGoalsAgainst": "0",
                "virtualPoints": "0",
                "rank": "1",
                "matchesDrawn": "0",
                "virtualMatchesWon": "0",
                "goalsFor": "0",
                "virtualRankSort": "1"
            }
        }, {
            "id": "GN891PZVRCA79YW",
            "names": {
                "short": "Serbia",
                "default": "Serbia",
                "full": "Serbia",
                "abbreviation": "SRB"
            },
            "images": {
                "jersey": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/shirt_home/large/3000.png",
                "teamLogo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3000.png"
            },
            "type": "TEAM",
            "typeDetail": "TEAM_NATIONAL",
            "nationality": {
                "names": {
                    "default": "Serbia",
                    "abbreviation": "SRB"
                },
                "images": {
                    "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/6944.png"
                }
            },
            "properties": {},
            "stats": {
                "virtualGoalsFor": "0",
                "virtualMatches": "0",
                "matchesWon": "0",
                "virtualRank": "1",
                "virtualMatchesLost": "0",
                "virtualGoalsDifference": "0",
                "virtualMatchesDrawn": "0",
                "matches": "0",
                "goalsDifference": "0",
                "points": "0",
                "rankSort": "2",
                "matchesLost": "0",
                "goalsAgainst": "0",
                "virtualGoalsAgainst": "0",
                "virtualPoints": "0",
                "rank": "1",
                "matchesDrawn": "0",
                "virtualMatchesWon": "0",
                "goalsFor": "0",
                "virtualRankSort": "2"
            }
        }, {
            "id": "GNCKSCV9KY3GCDW",
            "names": {
                "default": "Suiza",
                "abbreviation": "SUI",
                "full": "Suiza",
                "short": "Suiza"
            },
            "images": {
                "jersey": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/shirt_home/large/408.png",
                "teamLogo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/408.png"
            },
            "type": "TEAM",
            "typeDetail": "TEAM_NATIONAL",
            "nationality": {
                "names": {
                    "abbreviation": "SUI",
                    "default": "Suiza"
                },
                "images": {
                    "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2213.png"
                }
            },
            "properties": {},
            "stats": {
                "virtualGoalsFor": "0",
                "virtualMatches": "0",
                "matchesWon": "0",
                "virtualRank": "1",
                "virtualMatchesLost": "0",
                "virtualGoalsDifference": "0",
                "virtualMatchesDrawn": "0",
                "matches": "0",
                "goalsDifference": "0",
                "points": "0",
                "rankSort": "3",
                "matchesLost": "0",
                "goalsAgainst": "0",
                "virtualGoalsAgainst": "0",
                "virtualPoints": "0",
                "rank": "1",
                "matchesDrawn": "0",
                "virtualMatchesWon": "0",
                "goalsFor": "0",
                "virtualRankSort": "3"
            }
        }, {
            "id": "GNF40MXHR3YXM2S",
            "names": {
                "full": "Camerún",
                "abbreviation": "CMR",
                "default": "Camerún",
                "short": "Camerún"
            },
            "images": {
                "teamLogo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3075.png",
                "jersey": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/shirt_home/large/3075.png"
            },
            "type": "TEAM",
            "typeDetail": "TEAM_NATIONAL",
            "nationality": {
                "names": {
                    "default": "Camerún",
                    "abbreviation": "CMR"
                },
                "images": {
                    "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/4351.png"
                }
            },
            "properties": {},
            "stats": {
                "virtualGoalsFor": "0",
                "virtualMatches": "0",
                "matchesWon": "0",
                "virtualRank": "1",
                "virtualMatchesLost": "0",
                "virtualGoalsDifference": "0",
                "virtualMatchesDrawn": "0",
                "matches": "0",
                "goalsDifference": "0",
                "points": "0",
                "rankSort": "4",
                "matchesLost": "0",
                "goalsAgainst": "0",
                "virtualGoalsAgainst": "0",
                "virtualPoints": "0",
                "rank": "1",
                "matchesDrawn": "0",
                "virtualMatchesWon": "0",
                "goalsFor": "0",
                "virtualRankSort": "4"
            }
        }],
        "classifications": [{
            "id": "GS0005V0050WX9S",
            "names": {
                "default": "Puntos",
                "short": "Ptos."
            },
            "statKey": "points",
            "sort": "DESC",
            "order": 1,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WX9V",
            "names": {
                "default": "Partidos",
                "short": "P"
            },
            "statKey": "matches",
            "sort": "DESC",
            "order": 3,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WX9W",
            "names": {
                "short": "W",
                "default": "Won"
            },
            "statKey": "matchesWon",
            "sort": "DESC",
            "order": 4,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WX9X",
            "names": {
                "default": "Drawn",
                "short": "D"
            },
            "statKey": "matchesDrawn",
            "sort": "DESC",
            "order": 5,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WX9Z",
            "names": {
                "default": "Lost",
                "short": "L"
            },
            "statKey": "matchesLost",
            "sort": "DESC",
            "order": 6,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WX9b",
            "names": {
                "default": "goles a favor",
                "short": "GF"
            },
            "statKey": "goalsFor",
            "sort": "DESC",
            "order": 7,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WX9h",
            "names": {
                "short": "GC",
                "default": "goles en contra"
            },
            "statKey": "goalsAgainst",
            "sort": "DESC",
            "order": 8,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WX9m",
            "names": {
                "default": "Diferencia de goles",
                "short": "GD"
            },
            "statKey": "goalsDifference",
            "sort": "DESC",
            "order": 9,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WX9r",
            "names": {
                "short": "AGD",
                "default": "Away Goal Difference"
            },
            "statKey": "awayGoalsDifference",
            "sort": "DESC",
            "order": 10,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WX9t",
            "names": {
                "short": "HGD",
                "default": "Home Goal Difference"
            },
            "statKey": "homeGoalsDifference",
            "sort": "DESC",
            "order": 11,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WXB0",
            "names": {
                "default": "Home Points",
                "short": "HP"
            },
            "statKey": "homePoints",
            "sort": "DESC",
            "order": 12,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WXB2",
            "names": {
                "default": "Home Matches",
                "short": "HM"
            },
            "statKey": "homeMatches",
            "sort": "DESC",
            "order": 14,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WXB3",
            "names": {
                "default": "Won Home",
                "short": "WH"
            },
            "statKey": "homeMatchesWon",
            "sort": "DESC",
            "order": 15,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WXB4",
            "names": {
                "default": "Drawn Home",
                "short": "DH"
            },
            "statKey": "homeMatchesDrawn",
            "sort": "DESC",
            "order": 16,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WXB5",
            "names": {
                "default": "Lost Home",
                "short": "LH"
            },
            "statKey": "homeMatchesLost",
            "sort": "DESC",
            "order": 17,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WXB6",
            "names": {
                "default": "Home Goals For",
                "short": "HGF"
            },
            "statKey": "homeGoalsFor",
            "sort": "DESC",
            "order": 18,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WXB7",
            "names": {
                "short": "HGA",
                "default": "Home Goals Against"
            },
            "statKey": "homeGoalsAgainst",
            "sort": "DESC",
            "order": 19,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WXB8",
            "names": {
                "short": "AP",
                "default": "Away Points"
            },
            "statKey": "awayPoints",
            "sort": "DESC",
            "order": 20,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WXBB",
            "names": {
                "default": "Away Matches",
                "short": "AM"
            },
            "statKey": "awayMatches",
            "sort": "DESC",
            "order": 22,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WXBC",
            "names": {
                "short": "AW",
                "default": "Away Won"
            },
            "statKey": "awayMatchesWon",
            "sort": "DESC",
            "order": 23,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WXBD",
            "names": {
                "default": "Away Drawn",
                "short": "AD"
            },
            "statKey": "awayMatchesDrawn",
            "sort": "DESC",
            "order": 24,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WXBF",
            "names": {
                "short": "AL",
                "default": "Away Lost"
            },
            "statKey": "awayMatchesLost",
            "sort": "DESC",
            "order": 25,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WXBG",
            "names": {
                "short": "AGF",
                "default": "Away Goals For"
            },
            "statKey": "awayGoalsFor",
            "sort": "DESC",
            "order": 26,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WXBH",
            "names": {
                "short": "AGA",
                "default": "Away Goals Against"
            },
            "statKey": "awayGoalsAgainst",
            "sort": "DESC",
            "order": 27,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WXBJ",
            "names": {
                "short": "MIN",
                "default": "Min Rank"
            },
            "statKey": "minRank",
            "sort": "DESC",
            "order": 28,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WXBM",
            "names": {
                "default": "Max Rank",
                "short": "MAX"
            },
            "statKey": "maxRank",
            "sort": "DESC",
            "order": 29,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WXCF",
            "names": {
                "default": "Win percentage",
                "short": "PCT"
            },
            "statKey": "winPercentage",
            "sort": "DESC",
            "order": 57,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WXCG",
            "names": {
                "default": "Home win percentage",
                "short": "HPCT"
            },
            "statKey": "homeWinPercentage",
            "sort": "DESC",
            "order": 58,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WXCH",
            "names": {
                "default": "Away Win Percentage",
                "short": "APCT"
            },
            "statKey": "awayWinPercentage",
            "sort": "DESC",
            "order": 59,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WXCJ",
            "names": {
                "default": "Rango",
                "short": "Clas."
            },
            "statKey": "rank",
            "sort": "ASC",
            "order": 60,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WXRB",
            "names": {
                "short": "PR",
                "default": "Previous Rank"
            },
            "statKey": "prevRank",
            "sort": "ASC",
            "order": 61,
            "participantType": "TEAM"
        }, {
            "id": "GN8BNTY6YCWH9AJ",
            "names": {
                "default": "General Classification"
            },
            "statKey": "generalClassification",
            "participantType": "TEAM"
        }]
    }, {
        "phase": {
            "id": "GNDE9A5NB8NEE9C",
            "names": {
                "short": "H",
                "default": "Grupo H"
            },
            "dateAndTimeInfo": {},
            "status": {},
            "typeDetail": "PHASE_GROUP",
            "phaseNumber": 8,
            "sportId": "GNFB17MNF4TH4KM",
            "relatedSportsEvents": [{
                "id": "GNA5MGHG2ZVX2RD",
                "type": "LEAGUE"
            }, {
                "id": "GN1HX6DXNM8Q39W",
                "type": "LEAGUE_SEASON"
            }, {
                "id": "GN8N2CJNFGC0M4G",
                "type": "PHASE",
                "typeDetail": "PHASE_ROUND",
                "depth": 1
            }],
            "navigationInfo": {}
        },
        "participants": [{
            "id": "GN794EMZMP05YB5",
            "names": {
                "short": "Portugal",
                "abbreviation": "POR",
                "default": "Portugal",
                "full": "Portugal"
            },
            "images": {
                "teamLogo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/450.png",
                "jersey": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/shirt_home/large/450.png"
            },
            "type": "TEAM",
            "typeDetail": "TEAM_NATIONAL",
            "nationality": {
                "names": {
                    "default": "Portugal",
                    "abbreviation": "POR"
                },
                "images": {
                    "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2223.png"
                }
            },
            "properties": {},
            "stats": {
                "virtualGoalsFor": "0",
                "virtualMatches": "0",
                "matchesWon": "0",
                "virtualRank": "1",
                "virtualMatchesLost": "0",
                "virtualGoalsDifference": "0",
                "virtualMatchesDrawn": "0",
                "matches": "0",
                "goalsDifference": "0",
                "points": "0",
                "rankSort": "1",
                "matchesLost": "0",
                "goalsAgainst": "0",
                "virtualGoalsAgainst": "0",
                "virtualPoints": "0",
                "rank": "1",
                "matchesDrawn": "0",
                "virtualMatchesWon": "0",
                "goalsFor": "0",
                "virtualRankSort": "1"
            }
        }, {
            "id": "GN0MF7YTFAY301H",
            "names": {
                "full": "Ghana",
                "abbreviation": "GHA",
                "short": "Ghana",
                "default": "Ghana"
            },
            "images": {
                "jersey": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/shirt_home/large/3025.png",
                "teamLogo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3025.png"
            },
            "type": "TEAM",
            "typeDetail": "TEAM_NATIONAL",
            "nationality": {
                "names": {
                    "default": "Ghana",
                    "abbreviation": "GHA"
                },
                "images": {
                    "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/4339.png"
                }
            },
            "properties": {},
            "stats": {
                "virtualGoalsFor": "0",
                "virtualMatches": "0",
                "matchesWon": "0",
                "virtualRank": "1",
                "virtualMatchesLost": "0",
                "virtualGoalsDifference": "0",
                "virtualMatchesDrawn": "0",
                "matches": "0",
                "goalsDifference": "0",
                "points": "0",
                "rankSort": "2",
                "matchesLost": "0",
                "goalsAgainst": "0",
                "virtualGoalsAgainst": "0",
                "virtualPoints": "0",
                "rank": "1",
                "matchesDrawn": "0",
                "virtualMatchesWon": "0",
                "goalsFor": "0",
                "virtualRankSort": "2"
            }
        }, {
            "id": "GN8YCH3CR2Y7CC0",
            "names": {
                "abbreviation": "URU",
                "short": "Uruguay",
                "default": "Uruguay",
                "full": "Uruguay"
            },
            "images": {
                "teamLogo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3024.png",
                "jersey": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/shirt_home/large/3024.png"
            },
            "type": "TEAM",
            "typeDetail": "TEAM_NATIONAL",
            "nationality": {
                "names": {
                    "abbreviation": "URU",
                    "default": "Uruguay"
                },
                "images": {
                    "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2787.png"
                }
            },
            "properties": {},
            "stats": {
                "virtualGoalsFor": "0",
                "virtualMatches": "0",
                "matchesWon": "0",
                "virtualRank": "1",
                "virtualMatchesLost": "0",
                "virtualGoalsDifference": "0",
                "virtualMatchesDrawn": "0",
                "matches": "0",
                "goalsDifference": "0",
                "points": "0",
                "rankSort": "3",
                "matchesLost": "0",
                "goalsAgainst": "0",
                "virtualGoalsAgainst": "0",
                "virtualPoints": "0",
                "rank": "1",
                "matchesDrawn": "0",
                "virtualMatchesWon": "0",
                "goalsFor": "0",
                "virtualRankSort": "3"
            }
        }, {
            "id": "GN0MFWSX7TR5TC7",
            "names": {
                "short": "Corea",
                "full": "Corea del Sur",
                "abbreviation": "KOR",
                "default": "Corea del Sur"
            },
            "images": {
                "jersey": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/shirt_home/large/3068.png",
                "teamLogo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3068.png"
            },
            "type": "TEAM",
            "typeDetail": "TEAM_NATIONAL",
            "nationality": {
                "names": {
                    "default": "Corea",
                    "abbreviation": "KOR"
                },
                "images": {
                    "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/4391.png"
                }
            },
            "properties": {},
            "stats": {
                "virtualGoalsFor": "0",
                "virtualMatches": "0",
                "matchesWon": "0",
                "virtualRank": "1",
                "virtualMatchesLost": "0",
                "virtualGoalsDifference": "0",
                "virtualMatchesDrawn": "0",
                "matches": "0",
                "goalsDifference": "0",
                "points": "0",
                "rankSort": "4",
                "matchesLost": "0",
                "goalsAgainst": "0",
                "virtualGoalsAgainst": "0",
                "virtualPoints": "0",
                "rank": "1",
                "matchesDrawn": "0",
                "virtualMatchesWon": "0",
                "goalsFor": "0",
                "virtualRankSort": "4"
            }
        }],
        "classifications": [{
            "id": "GS0005V0050WZ8m",
            "names": {
                "default": "Puntos",
                "short": "Ptos."
            },
            "statKey": "points",
            "sort": "DESC",
            "order": 1,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WZ8t",
            "names": {
                "default": "Partidos",
                "short": "P"
            },
            "statKey": "matches",
            "sort": "DESC",
            "order": 3,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WZ90",
            "names": {
                "short": "W",
                "default": "Won"
            },
            "statKey": "matchesWon",
            "sort": "DESC",
            "order": 4,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WZ91",
            "names": {
                "default": "Drawn",
                "short": "D"
            },
            "statKey": "matchesDrawn",
            "sort": "DESC",
            "order": 5,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WZ92",
            "names": {
                "default": "Lost",
                "short": "L"
            },
            "statKey": "matchesLost",
            "sort": "DESC",
            "order": 6,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WZ93",
            "names": {
                "default": "goles a favor",
                "short": "GF"
            },
            "statKey": "goalsFor",
            "sort": "DESC",
            "order": 7,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WZ94",
            "names": {
                "short": "GC",
                "default": "goles en contra"
            },
            "statKey": "goalsAgainst",
            "sort": "DESC",
            "order": 8,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WZ95",
            "names": {
                "default": "Diferencia de goles",
                "short": "GD"
            },
            "statKey": "goalsDifference",
            "sort": "DESC",
            "order": 9,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WZ96",
            "names": {
                "short": "AGD",
                "default": "Away Goal Difference"
            },
            "statKey": "awayGoalsDifference",
            "sort": "DESC",
            "order": 10,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WZ97",
            "names": {
                "short": "HGD",
                "default": "Home Goal Difference"
            },
            "statKey": "homeGoalsDifference",
            "sort": "DESC",
            "order": 11,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WZ98",
            "names": {
                "default": "Home Points",
                "short": "HP"
            },
            "statKey": "homePoints",
            "sort": "DESC",
            "order": 12,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WZ9B",
            "names": {
                "default": "Home Matches",
                "short": "HM"
            },
            "statKey": "homeMatches",
            "sort": "DESC",
            "order": 14,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WZ9C",
            "names": {
                "default": "Won Home",
                "short": "WH"
            },
            "statKey": "homeMatchesWon",
            "sort": "DESC",
            "order": 15,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WZ9D",
            "names": {
                "default": "Drawn Home",
                "short": "DH"
            },
            "statKey": "homeMatchesDrawn",
            "sort": "DESC",
            "order": 16,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WZ9F",
            "names": {
                "default": "Lost Home",
                "short": "LH"
            },
            "statKey": "homeMatchesLost",
            "sort": "DESC",
            "order": 17,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WZ9G",
            "names": {
                "default": "Home Goals For",
                "short": "HGF"
            },
            "statKey": "homeGoalsFor",
            "sort": "DESC",
            "order": 18,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WZ9H",
            "names": {
                "short": "HGA",
                "default": "Home Goals Against"
            },
            "statKey": "homeGoalsAgainst",
            "sort": "DESC",
            "order": 19,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WZ9J",
            "names": {
                "short": "AP",
                "default": "Away Points"
            },
            "statKey": "awayPoints",
            "sort": "DESC",
            "order": 20,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WZ9N",
            "names": {
                "default": "Away Matches",
                "short": "AM"
            },
            "statKey": "awayMatches",
            "sort": "DESC",
            "order": 22,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WZ9P",
            "names": {
                "short": "AW",
                "default": "Away Won"
            },
            "statKey": "awayMatchesWon",
            "sort": "DESC",
            "order": 23,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WZ9R",
            "names": {
                "default": "Away Drawn",
                "short": "AD"
            },
            "statKey": "awayMatchesDrawn",
            "sort": "DESC",
            "order": 24,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WZ9S",
            "names": {
                "short": "AL",
                "default": "Away Lost"
            },
            "statKey": "awayMatchesLost",
            "sort": "DESC",
            "order": 25,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WZ9T",
            "names": {
                "short": "AGF",
                "default": "Away Goals For"
            },
            "statKey": "awayGoalsFor",
            "sort": "DESC",
            "order": 26,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WZ9V",
            "names": {
                "short": "AGA",
                "default": "Away Goals Against"
            },
            "statKey": "awayGoalsAgainst",
            "sort": "DESC",
            "order": 27,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WZ9W",
            "names": {
                "short": "MIN",
                "default": "Min Rank"
            },
            "statKey": "minRank",
            "sort": "DESC",
            "order": 28,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WZ9X",
            "names": {
                "default": "Max Rank",
                "short": "MAX"
            },
            "statKey": "maxRank",
            "sort": "DESC",
            "order": 29,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WZBS",
            "names": {
                "default": "Win percentage",
                "short": "PCT"
            },
            "statKey": "winPercentage",
            "sort": "DESC",
            "order": 57,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WZBT",
            "names": {
                "default": "Home win percentage",
                "short": "HPCT"
            },
            "statKey": "homeWinPercentage",
            "sort": "DESC",
            "order": 58,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WZBV",
            "names": {
                "default": "Away Win Percentage",
                "short": "APCT"
            },
            "statKey": "awayWinPercentage",
            "sort": "DESC",
            "order": 59,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WZBW",
            "names": {
                "default": "Rango",
                "short": "Clas."
            },
            "statKey": "rank",
            "sort": "ASC",
            "order": 60,
            "participantType": "TEAM"
        }, {
            "id": "GS0005V0050WZPN",
            "names": {
                "short": "PR",
                "default": "Previous Rank"
            },
            "statKey": "prevRank",
            "sort": "ASC",
            "order": 61,
            "participantType": "TEAM"
        }, {
            "id": "GN83C84Z2P84P57",
            "names": {
                "default": "General Classification"
            },
            "statKey": "generalClassification",
            "participantType": "TEAM"
        }]
    }]
}`)


// WEBPACK FOOTER //
// ./src/mundial/requests/mockData/standings.ts